import { createContext, useCallback, useState } from 'react';
import { useApi } from '../../hooks/useApi';

import {
  PreSelectionType,
  PricingSheet,
  SelectSheetOption,
} from '../../../../shared/types';
import { addDays, endOfDay, startOfDay, subYears } from 'date-fns';
import { RentalHistorySourceType } from '../../../../shared/types/pricingSheets';
import { useQueryClient } from '@tanstack/react-query';
import {
  EXTERNAL_SHEET_COMPARISON,
  EXTERNAL_SHEET_ITEMS_COMPARISON,
  SHEET_ITEMS_COMPARISON,
} from '../../../../shared/constants';

const Pricing = createContext<any | null>(null);

const PricingProvider = (props: any) => {
  const queryClient = useQueryClient();

  const [showMachineCard, setShowMachineCard] = useState(true);
  const [itemFilterValue, setItemFilterValue] = useState<
    string | undefined
  >('');
  const [pricingSheetId, setPricingSheetId] = useState<
    string | undefined
  >(undefined);

  const [selectedPreSelection, setSelectedPreSelection] = useState<
    PreSelectionType | undefined
  >();

  const [externalPricingSheetId, setExternalPricingSheetId] =
    useState<number | undefined>();

  const [miraSheetIdExternal, setMiraSheetIdExternal] = useState<
    number | undefined
  >(undefined);

  const [comparisonPricingSheets] = useApi<
    PricingSheet[] | [] | undefined
  >('/pricingsheets');

  const [comparisonSheetName, setComparisonSheetName] = useState('');
  const [comparisonSheetRows, setComparisonSheetRows] = useState();

  const [
    externalSheetSelectedOption,
    setExternalSheetSelectedOption,
  ] = useState<SelectSheetOption | undefined>(undefined);

  const clearItemFilterValue = () => {
    setItemFilterValue('');
  };

  const [rentalHistoryProvider, setRentalHistoryProvider] = useState({
    startDate: startOfDay(addDays(subYears(new Date(), 1), 1)),
    endDate: endOfDay(startOfDay(new Date())),
    customer: '',
    customerId: '',
    companyId: '',
    companyName: '',
    sourceType: RentalHistorySourceType.Customer,
  });

  const updateRentalHistoryProvider = (
    key: keyof typeof rentalHistoryProvider,
    value: any,
  ) => {
    setRentalHistoryProvider((prev) => ({ ...prev, [key]: value }));
  };

  const resetPricingProvider = useCallback(() => {
    setPricingSheetId(undefined);
    setSelectedPreSelection(undefined);
    setExternalPricingSheetId(undefined);
    setExternalSheetSelectedOption(undefined);
    setMiraSheetIdExternal(undefined);
    setExternalPricingSheetId && setExternalPricingSheetId(undefined);
    updateRentalHistoryProvider('customer', '');
    updateRentalHistoryProvider('customerId', '');
    updateRentalHistoryProvider('companyId', '');
    updateRentalHistoryProvider('companyName', '');

    // Clear SearchExternalSheet component's queries
    queryClient.removeQueries({
      queryKey: [EXTERNAL_SHEET_ITEMS_COMPARISON],
    });
    queryClient.removeQueries({
      queryKey: [EXTERNAL_SHEET_COMPARISON],
    });
    queryClient.removeQueries({
      queryKey: [SHEET_ITEMS_COMPARISON],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const children = props.children;

  return (
    <Pricing.Provider
      value={{
        itemFilterValue,
        setItemFilterValue,
        clearItemFilterValue,
        pricingSheetId,
        setPricingSheetId,
        comparisonPricingSheets,
        externalPricingSheetId,
        setExternalPricingSheetId,
        showMachineCard,
        setShowMachineCard,
        selectedPreSelection,
        setSelectedPreSelection,
        comparisonSheetName,
        setComparisonSheetName,
        externalSheetSelectedOption,
        setExternalSheetSelectedOption,
        // rentalHistory,
        // isLoadingRentalHistory,
        rentalHistoryProvider,
        updateRentalHistoryProvider,
        resetPricingProvider,
        miraSheetIdExternal,
        setMiraSheetIdExternal,
        comparisonSheetRows,
        setComparisonSheetRows,
      }}
    >
      {children}
    </Pricing.Provider>
  );
};

export default Pricing;

export { PricingProvider };
